<template>
  <div>
    <!-- actions -->
    <template slot="action">
      <a-button-group style="margin-right: 4px;">
        <a-button>操作</a-button>
        <a-button>操作</a-button>
        <a-button>
          <a-icon type="ellipsis"/>
        </a-button>
      </a-button-group>
      <a-button type="primary">主操作</a-button>
    </template>

    <a-card style="margin-top: 24px" :bordered="false">
      <a-steps :current="currentStep"  v-if="false">
        <a-step v-for="(step,index) in stepList" :key="" index
                :status="currentStep==index?'process': (step.status==2? 'finish':'wait') " :title="step.name"
                :description="step.time_start_str+' 至 '+step.time_end_str"/>
      </a-steps>
      <a-steps :current="currentStep">
        <a-step status="finish" @click="currentStep=0">
          <!-- <span slot="title">Finished</span> -->
          <template slot="title">
            报名准备
          </template>
          <span slot="description"></span>
        </a-step>
        <a-step @click="currentStep=1" :status="currentStep==1?'process':'wait'" title="报名环节" description="距比赛开始40-20天前"/>
        <a-step @click="currentStep=2" :status="currentStep==2?'process':'wait'" title="赛前准备" description="距比赛开始20-3天"/>
        <a-step @click="currentStep=3" :status="currentStep==3?'process':'wait'" title="比赛环节" description=""/>
        <a-step @click="currentStep=4" :status="currentStep==4?'process':'wait'" title="比赛结束" description="比赛结束后5天"/>
      </a-steps>
    </a-card>

    <a-card style=" " :bordered="true">
      <detail-list :col="2">
        <detail-list-item term="赛区名称">{{ saiqu.name }}</detail-list-item>
        <detail-list-item term="报名时间">{{ saiqu.stime }} 至 {{ saiqu.etime }}</detail-list-item>
        <detail-list-item term="比赛时间">{{ saiqu.saidate }} 至 {{ saiqu.saidate_end }}</detail-list-item>
        <detail-list-item term="举办地区">{{ saiqu.province }}{{ saiqu.city }}{{ saiqu.county }}</detail-list-item>
      </detail-list>

      <a-button @click="download(1)">赛事对接包和通用模板下载<a-icon type="download"/></a-button>
      <a-button @click="download(2)">中国俱乐部比赛下载<a-icon type="download"/></a-button>
      <a-button @click="download(3)">少儿精英赛模板下载<a-icon type="download"/></a-button>
      <a-button @click="download(4)">最新联赛下载<a-icon type="download"/></a-button>
    </a-card>
    <!-- 操作 -->
    <a-card
        style="margin-top: 24px"
        :bordered="false"
    >
      <a-tabs defaultActiveKey="1">
        <a-tab-pane tab="CCA任务清单" key="1">
          <a-table
              rowKey="id"
              :columns="serviceLogColumns"
              :dataSource="serviceListf"
              :pagination="false"
          >
          <span slot="status" slot-scope="text,record">
            <a-badge v-if="record.status==1" status="warning" text="待处理"/>
            <a-badge v-else-if="record.status==2" status="success" text="已完成"/>
            <a-badge v-else-if="record.status==3" status="error" text="逾期"/>
          </span>
            <span slot="file_status" slot-scope="text,record">
              <a-tag v-if="record.files.length>=1" color="green">已上传</a-tag>
            <a-tag v-else>未上传</a-tag>
          </span>
            <p slot="expandedRowRender" slot-scope="record" style="margin: 0">
              <span v-html="record.desc"></span>
            </p>
            <span slot="complete_time" slot-scope="text,record">
            计划 {{ record.plan_time_str }}<br/>
            <em v-if="record.complete_time>0">实际 {{ record.complete_time_str }}</em>
          </span>

          <span slot="rank" slot-scope="text,record">
        <template>
        <editable-cell :text="text" @change="onRankChange(record.id, 'rank', $event)"/>
        </template>
      </span>   
            <span slot="actions" slot-scope="text,record,index">
              <!--<a   >下载</a>-->
    <a-divider type="vertical"/>
              <a v-if="record.admin_status==1" @click="orderServiceEdit(record.id,index)">处理</a>
              <a v-else @click="taskEdit(record)">操作</a>
          </span>
          </a-table>

        </a-tab-pane>
        <a-tab-pane tab="省市任务清单" key="2">
          <a-table
              rowKey="id"
              :columns="serviceLogColumns"
              :dataSource="serviceListw"
              :pagination="false"
          >
          <span slot="status" slot-scope="text,record">
            <a-badge v-if="record.status==1" status="warning" text="待处理"/>
            <a-badge v-else-if="record.status==2" status="success" text="已完成"/>
            <a-badge v-else-if="record.status==3" status="error" text="逾期"/>
          </span>
            <span slot="file_status" slot-scope="text,record">
              <a-tag v-if="record.files.length>=1" color="green">已上传</a-tag>
            <a-tag v-else>未上传</a-tag>
          </span>
            <p slot="expandedRowRender" slot-scope="record" style="margin: 0">
              <span v-html="record.desc"></span>
            </p>
            <span slot="complete_time" slot-scope="text,record">
            计划 {{ record.plan_time_str }}<br/>
            <em v-if="record.complete_time>0">实际 {{ record.complete_time_str }}</em>
          </span>

          <span slot="rank" slot-scope="text,record">
        <template>
        <editable-cell :text="text" @change="onRankChange(record.id, 'rank', $event)"/>
        </template>
      </span>   
            <span slot="actions" slot-scope="text,record,index">
              <!--<a   >下载</a>-->
    <a-divider type="vertical"/>
              <a v-if="record.admin_status==1" @click="orderServiceEdit(record.id,index)">处理</a>
              <a v-else @click="taskEdit(record)">操作</a>
          </span>
          </a-table>

        </a-tab-pane>
      </a-tabs>


    </a-card>


    <a-affix :offsetBottom="0">
      <div style="background: #fff; padding: 10px 0 20px 10px ; border-top: 1px solid #eee ; text-align: center  ">
        <a-button-group>
          <a-button size="large" style="margin-right: 10px" @click="currentStep--" :disabled="currentStep==0">
            <a-icon type="left"/>
            上一步
          </a-button>
          <a-button size="large" type="primary" @click="currentStep++" :disabled="currentStep==4">下一步
            <a-icon type="right"/>
          </a-button>
        </a-button-group>
      </div>
    </a-affix>


    <a-modal
        :maskClosable="false"
        title="操作"
        :width="1200"
        v-model="taskVisible"
        @ok="handleTaskOk(0)"
    >
      <a-spin :spinning="saveLoading">
        <a-form>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="任务名称"
                  hasFeedback
              > 
                <a-input v-model="taskFormData.name"
                         placeholder="请输入任务名称"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="任务说明"
                  hasFeedback
              > 
                <a-textarea v-model="taskFormData.desc"
                         placeholder="请输入任务说明"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="附件上传"
                  hasFeedback
              >
                <file-uploader
                    :file-list="taskFormData.files"
                />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="图片上传"
                  hasFeedback
              >
                <pic-uploader
                    :file-list="taskFormData.pics"
                />
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="备注信息"
                  hasFeedback
              >
                <a-input v-model="taskFormData.note"
                         placeholder="请输入备注信息"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="保留上传文件"
                  hasFeedback
              >
                <r-switch :formData="taskFormData" field="need_upload_file" :checkedValue="1" :unCheckedValue="2"
                          checkedChildren="需要" unCheckedChildren="不需要"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="工作评价"
                  hasFeedback
              >
                <a-rate v-model='taskFormData.score'/>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleTaskCancel()">取消</a-button>

        <a-popconfirm title="确定完成本任务吗?此操作不可恢复" @confirm="handleTaskOk(2)" okText="确定" cancelText="取消">
          <a-button key="yes" :loading="saveLoading" type="primary">完成任务</a-button>
        </a-popconfirm>
        <a-button key="save" :loading="saveLoading" @click="handleTaskOk(0)" type="primary">仅保存</a-button>
      </template>
    </a-modal>


    <a-modal
        :maskClosable="false"
        title="调价操作"
        :width="800"
        v-model="priceVisible"
        @ok="handlePirceSave"
    >
      <a-spin :spinning="saveLoading">
        <a-form>
          <a-form-item
              label="手动调价"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              extra="正数是加价,负数是减价"
          >
            <PriceInput :formData="priceFormData"
                        field="price"
                        placeholder="手动调价"/>
          </a-form-item>
          <a-form-item
              label="调价理由"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
          >
            <a-input
                v-model="priceFormData.comment"
                placeholder="请输入理由"/>
          </a-form-item>
        </a-form>
      </a-spin>
    </a-modal>


    <a-modal
        :maskClosable="false"
        title="退款退货操作"
        :width="800"
        v-model="refundVisible"
        @ok="handleRefundSave"
    >
      <a-spin :spinning="saveLoading">
        <a-form>
          <a-form-item
              label="退款"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              :extra="'已付'+(refundFormData.pay_price)+'元,已退'+(refundFormData.refund_price)+'元,最多可退'+((refundFormData.pay_price-refundFormData.refund_price))+'元'"
          >
            <PriceInput :formData="refundFormData"
                        field="price"
                        placeholder="输入退款金额"/>
          </a-form-item>
          <a-form-item
              label="退货数量"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              :extra="'购买'+(refundFormData.buy_count)+'件,已退'+(refundFormData.refund_count)+'件,最多可退'+(refundFormData.buy_count-refundFormData.refund_count)+'件'"
          >
            <a-input
                type="number"
                v-model="refundFormData.count"
                placeholder="请输入退货数量"/>
          </a-form-item>

          <a-form-item
              label="理由"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
          >
            <a-input
                v-model="refundFormData.comment"
                placeholder="请输入理由"/>
          </a-form-item>
        </a-form>
      </a-spin>
    </a-modal>


  </div>


</template>

<script>
import {mixinDevice} from '@/utils/mixin'
import {getSaiDateDetail, getTaskDetail, taskEdit,setTaskRank} from '@/api/sai'
import {PageView} from '@/components/layouts'
import DetailList from '@/components/tools/DetailList'
import PriceInput from '@/components/PriceInput/'
import PicUploader from '@/components/PicUploader/'
import EditableCell from '@/components/EditableCell/'
import FileUploader from '@/components/FileUploader/'
import RSwitch from '@/components/RSwitch/'

const DetailListItem = DetailList.Item
import {getOrderDetail, orderConfirm, orderUse} from '@/api/shopOrder'

export default {
  name: 'ShopOrderDetail',
  components: {
    PageView,
    FileUploader,
    PicUploader,
    DetailList,
    PriceInput,
    DetailListItem,
    EditableCell,
    RSwitch
  },
  mixins: [mixinDevice],
  data() {
    return {
      currentStep: 0,
      labelCol: {
        xs: {span: 24},
        sm: {span: 5},
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 12},
      },
      businessNoteEdit: false,
      adminNoteEdit: false,
      saveLoading: false,
      saiqu_id: this.$route.query.id,
      taskVisible: false,
      priceVisible: false,
      refundVisible: false,
      priceFormData: {
        order_goods_id: 0,
        comment: '',
        price: 0
      },
      refundFormData: {
        order_goods_id: 0,
        order_id: 0,
        pay_price: 0,
        refund_price: 0,
        refund_count: 0,
        buy_count: 0,
        count: 0,
        price: 0,
        comment: '',
      },
      taskFormData: {
        id: 0,
        note: '',
        need_upload_file: 2,
        score: 0,
        files: [],
        pics: []
      },
      serviceList: [],
      stepList: [],
      saiqu: {},
      logList: [],
      row: {
        buyer: {
          name: '',
          phone: ''
        },
        items: [],
        logList: [{
          user_name: '宋巨报',
          title: '完成了登陆网站测试报名数据',
          create_time: '2020-12-11',
          note: ''
        }],
        serviceList: [
          {
            id: 1,
            step: 0,
            description: '',
            title: '建立工作微信群',
            admin_status: 1,
            admin_user_name: '-',
            complete_time: '',
            plan_time: '2020-12-12',
          },
          {
            id: 2,
            step: 0,
            title: '建立比赛群',
            admin_status: 2,
            description: '',
            admin_user_name: '宋巨报',
            complete_time: '2020-12-17',
            plan_time: '2020-12-12',
          },
          {
            id: 3,
            step: 0,
            title: '登陆网站测试报名数据',
            admin_status: 3,
            description: '',
            admin_user_name: '周婷婷',
            complete_time: '2020-12-11',
            plan_time: '2020-12-12',
          },
          {
            id: 4,
            step: 1,
            title: '新备案单位审核',
            admin_status: 1,
            description: '',
            admin_user_name: '',
            complete_time: '',
            plan_time: '2020-12-12',
          },
          {
            id: 6,
            step: 2,
            title: '访问下载赛事对接报表',
            admin_status: 1,
            description: '上传场地情况图、参数、搭建方案',
            admin_user_name: '',
            complete_time: '',
            plan_time: '2020-12-12',
          },
          {
            id: 7,
            step: 2,
            title: '制作日程表',
            description: '',
            admin_status: 1,
            admin_user_name: '',
            complete_time: '',
            plan_time: '2020-12-12',
          },
          {
            id: 8,
            step: 2,
            title: '制作组委会名单',
            description: '',
            admin_status: 1,
            admin_user_name: '',
            complete_time: '',
            plan_time: '2020-12-12',
          },
          {
            id: 9,
            step: 2,
            title: '制作开幕式议程',
            description: '',
            admin_status: 1,
            admin_user_name: '',
            complete_time: '',
            plan_time: '2020-12-12',
          },
          {
            id: 10,
            step: 2,
            title: '制作领队会议程',
            admin_status: 1,
            description: '',
            admin_user_name: '',
            complete_time: '',
            plan_time: '2020-12-12',
          },
          {
            id: 11,
            step: 2,
            title: '办公物料清单确认',
            admin_status: 1,
            description: '',
            admin_user_name: '',
            complete_time: '',
            plan_time: '2020-12-12',
          },
          {
            id: 12,
            step: 2,
            title: '场地物料清单确认',
            admin_status: 1,
            description: '确认印刷制品：确认引导牌、背景板、照片墙（横5M*竖4M）、指示牌、欢迎喷绘、回头标、签名墙、横幅、餐券、车证、工作证件、门票、参赛手册、奖金牌、桌前版、号码牌、广告板、席卡、小C小A拍照喷绘、吉祥物、道旗、拱门、空飘等',
            admin_user_name: '',
            complete_time: '',
            plan_time: '2020-12-12',
          },
          {
            id: 13,
            step: 2,
            title: '媒体邀请名单确认',
            admin_status: 1,
            description: '',
            admin_user_name: '',
            complete_time: '',
            plan_time: '2020-12-12',
          },
          {
            id: 14,
            step: 2,
            title: '赞助清单赛前上传场地协议、赞助协议盖章版',
            admin_status: 1,
            admin_user_name: '',
            description: '',
            complete_time: '',
            plan_time: '2020-12-12',
          },
          {
            id: 15,
            step: 2,
            title: '场地医生到岗时间表确认',
            admin_status: 1,
            admin_user_name: '',
            description: '',
            complete_time: '',
            plan_time: '2020-12-12',
          },
          {
            id: 16,
            step: 2,
            title: '志愿者名单确认',
            admin_status: 1,
            description: '',
            admin_user_name: '',
            complete_time: '',
            plan_time: '2020-12-12',
          },
          {
            id: 17,
            step: 2,
            title: '报名须知和参赛指南下载',
            admin_status: 1,
            admin_user_name: '',
            description: '',
            complete_time: '',
            plan_time: '2020-12-12',
          },
          {
            id: 18,
            step: 2,
            title: '直播分单机位直播和手机直播',
            admin_status: 1,
            admin_user_name: '',
            description: '',
            complete_time: '',
            plan_time: '2020-12-12',
          },
          {
            id: 19,
            step: 3,
            title: '核对秩序册信息',
            admin_status: 1,
            description: '',
            admin_user_name: '',
            complete_time: '',
            plan_time: '2020-12-12',
          },
          {
            id: 20,
            step: 3,
            title: '编排出场顺序',
            admin_status: 1,
            admin_user_name: '',
            description: '',
            complete_time: '',
            plan_time: '2020-12-12',
          },
          {
            id: 21,
            step: 3,
            title: '走场顺序确认',
            admin_status: 1,
            admin_user_name: '',
            description: '',
            complete_time: '',
            plan_time: '2020-12-12',
          },
          {
            id: 22,
            step: 3,
            title: '仲裁录像',
            admin_status: 1,
            admin_user_name: '',
            description: '（一）确定看场地人员，前往勘察场地（详见仲裁录像流程）；<br/>' +
                '（二）确认场地机位高度及位置，现场亮度，电源接口，观众的分布情况；<br/>' +
                '（三）出发前最后测试检查机器，确认物料运输方式是否安全；<br/>' +
                '（四）确认仲裁录像是否正常运行；<br/>' +
                '（五）确认录像是否拷贝以及备份，确认物料齐全上车发回。',
            complete_time: '',
            plan_time: '2020-12-12',
          },
          {
            id: 23,
            step: 3,
            title: '直播',
            admin_status: 1,
            description: '',
            admin_user_name: '',
            complete_time: '',
            plan_time: '2020-12-12',
          },
          {
            id: 24,
            step: 3,
            title: '摄影',
            admin_status: 1,
            description: '',
            admin_user_name: '',
            complete_time: '',
            plan_time: '2020-12-12',
          },
          {
            id: 25,
            step: 3,
            title: '赛事确认报到流程',
            description: '',
            admin_status: 1,
            admin_user_name: '',
            complete_time: '',
            plan_time: '2020-12-12',
          },
          {
            id: 26,
            step: 3,
            title: '安排保护人员',
            admin_status: 1,
            admin_user_name: '',
            description: '',
            complete_time: '',
            plan_time: '2020-12-12',
          },
          {
            id: 27,
            step: 4,
            title: '成绩发布',
            description: '',
            admin_status: 1,
            admin_user_name: '',
            complete_time: '',
            plan_time: '2020-12-12',
          },
          {
            id: 28,
            step: 4,
            title: '上传赛事文件',
            admin_status: 1,
            admin_user_name: '',
            description: '',
            complete_time: '',
            plan_time: '2020-12-12',
          },
          {
            id: 29,
            step: 4,
            title: '费用结算',
            admin_status: 1,
            admin_user_name: '',
            description: '',
            complete_time: '',
            plan_time: '2020-12-12',
          }
        ],
        step_list: [],
        status_data: {
          step: 0,
          buttons: []
        }
      },
      goodsColumns: [
        {
          title: '#',
          dataIndex: 'id'
        },
        {
          title: '商品',
          dataIndex: 'title',
          scopedSlots: {customRender: 'goods'}
        },
        {
          title: '数量',
          dataIndex: 'count',
          scopedSlots: {customRender: 'count'}
        },
        {
          title: '价格信息',
          dataIndex: 'goods_price',
          scopedSlots: {customRender: 'goods_price'}
        },
        {
          title: '提成',
          dataIndex: 'rewards_price',
          scopedSlots: {customRender: 'rewards_price'}
        },
        // {
        //   title: '操作',
        //   dataIndex: 'actions',
        //   scopedSlots: { customRender: 'actions' }
        // }
      ],
      serviceLogColumns: [
        {
          title: '任务说明',
          dataIndex: 'name',
        },
        {
          title: '文件上传状态',
          dataIndex: 'file_status',
          scopedSlots: {customRender: 'file_status'}
        },
        {
          title: '状态',
          dataIndex: 'admin_status',
          scopedSlots: {customRender: 'status'}
        },
        {
          title: '完成时间',
          dataIndex: 'complete_time',
          scopedSlots: {customRender: 'complete_time'}
        },
        {
          title: '操作人',
          dataIndex: 'user_name',
        },
        {
            title: '排序',
            dataIndex: 'rank',
            scopedSlots: {customRender: 'rank'},
        },
        {
          title: '操作',
          dataIndex: 'id',
          scopedSlots: {customRender: 'actions'}
        }
      ]
    }
  },
  computed: {
    serviceListf: function () {
      let that = this;
      let list = this.serviceList.filter(item => {
        return item.step == that.currentStep && item.show_type == 'app';
      });
      console.log('this.serviceList.filter');
      console.log(list);
      return list;
    },
    serviceListw: function () {
      let that = this;
      let list = this.serviceList.filter(item => {
        return item.step == that.currentStep && item.show_type == 'weiyuanhui';
      });
      console.log('this.serviceList.filter');
      console.log(list);
      return list;
    }
  },

  mounted() {
    let that = this;
    that.getDetail(true);
  },
  methods: {
    getDetail(fresh) {
      let that = this;
      getSaiDateDetail({
        saiqu: that.saiqu_id
      }).then(res => {
        if(fresh){ 
          that.currentStep = res.data.current_step;
        }
        that.serviceList = res.data.task_list;
        that.stepList = res.data.step_list;
        that.logList = res.data.log_list;
        that.saiqu = res.data.saiqu;
      }).catch(err => {
        self.$message.error(err.data.msg)
      })
    },

    handleRefundSave() {

    },
    handlePirceSave() {

    },

    taskEdit(record) {
      let that = this;
      that.taskVisible = true;

      getTaskDetail({id: record.id}).then(res => {
        setTimeout(() => {
          console.log('handleEdit')
          that.taskFormData = {...res.data};
        }, 200)
      })


    },
    handleTaskCancel() {
      let that = this;
      that.taskVisible = false;
    },
    handleTaskOk(type) {
      let that = this;
      that.saveLoading = true;
      taskEdit({
        id: that.taskFormData.id,
        name: that.taskFormData.name,
        desc: that.taskFormData.desc,
        note: that.taskFormData.note,
        need_upload_file: that.taskFormData.need_upload_file,
        score: that.taskFormData.score,
        pics: that.taskFormData.pics,
        files: that.taskFormData.files,
        status: type
      }).then(res => {
        that.getDetail();
        that.$message.success('处理成功')
        that.taskVisible = false;
        that.saveLoading = false;
      }).catch(err => {
        that.saveLoading = false;
        that.$message.error(err.data.msg)
      })
    },
    onBusinessNoteEdit() {
      let that = this;
      that.businessNoteEdit = false;
      businessNoteEdit({
        id: that.row.id,
        note: that.row.business_note,
      }).then(res => {
      }).catch(err => {
        that.$message.error(err.data.msg)
      })
    },
    onAdminNoteEdit() {
      let that = this;
      that.adminNoteEdit = false;
      adminNoteEdit({
        id: that.row.id,
        note: that.row.admin_note,
      }).then(res => {
      }).catch(err => {
        that.$message.error(err.data.msg)
      })
    }, 
    onRankChange(key, dataIndex, value) {
        let self = this;
        setTaskRank({
            id: key,
            rank: value
        }).then(res => {
            self.getDetail();
        }).catch(err => {
            self.$message.error(err.data.msg)
        })
    },
  },
  filters: {}
}
</script>

<style lang="less" scoped>
.detail-layout {
  margin-left: 44px;
}

.text {
  color: rgba(0, 0, 0, .45);
}

.heading {
  color: rgba(0, 0, 0, .85);
  font-size: 20px;
}

.no-data {
  color: rgba(0, 0, 0, .25);
  text-align: center;
  line-height: 64px;
  font-size: 16px;

  i {
    font-size: 24px;
    margin-right: 16px;
    position: relative;
    top: 3px;
  }
}

.mobile {
  .detail-layout {
    margin-left: unset;
  }

  .text {
  }

  .status-list {
    text-align: left;
  }
}

</style>
